import { magnoliaServiceAPI } from '@/store/api-instance'
import { IFetchSelectedBrandsRequest } from '@/store/modules/brands/interfaces/selectedBrands/api/fetchSelectedBrands/IFetchSelectedBrandsRequest'

import { IBrands } from '@/store/modules/brands/interfaces/IBrands'

import { IFetchBrandsRequest } from '@/store/modules/brands/interfaces/brands/api/fetchBrands/IFetchBrandsRequest'
import { IFetchBrandsResponse } from '@/store/modules/brands/interfaces/brands/api/fetchBrands/IFetchBrandsResponse'
import { AxiosResponse } from 'axios'

export const brandsAPI = {

  async fetchOurBrands (dto: IFetchBrandsRequest): Promise<IFetchBrandsResponse> {
    const ourBrandApi = 'ourbrand'
    const response: AxiosResponse = await magnoliaServiceAPI.get<IFetchBrandsResponse>(ourBrandApi, { params: dto })
    return response.data
  },

  async fetchOurBrandsAfterLogin (customerType: string): Promise<IFetchBrandsResponse> {
    const ourBrandApi = 'banners'
    const response: AxiosResponse = await magnoliaServiceAPI.get<IFetchBrandsResponse>(ourBrandApi, { params: { locationId: 'brandlogosAfterLogin', CustomerType: customerType } })
    return response.data
  },

  async fetchAllOurBrands (dto: IFetchSelectedBrandsRequest): Promise<IBrands> {
    const allOurBrandApi = 'ourbrand/GetAllOurBrandsDetails'
    const response: AxiosResponse = await magnoliaServiceAPI.get<IBrands>(allOurBrandApi, { params: dto })
    return response.data
  }
}
